/**
 * Translate Notify Me! app button labels to German.
 * App injects buttons asynchronously, so we watch the DOM.
 */
(function () {
  var LABEL = 'Benachrichtige mich';
  var RE = /^\s*notify\s*me\s*!?\s*$/i;

  function translate(node) {
    if (!node || node.nodeType !== 1) return;

    var candidates = [];
    if (node.matches && node.matches('.restock-alerts-notify-button, .COLLECTION_PAGE-notify-button, .LANDING_PAGES-notify-button, .PRODUCT_PAGE-notify-button')) {
      candidates.push(node);
    }
    if (node.querySelectorAll) {
      node.querySelectorAll('.restock-alerts-notify-button, .COLLECTION_PAGE-notify-button, .LANDING_PAGES-notify-button, .PRODUCT_PAGE-notify-button').forEach(function (el) {
        candidates.push(el);
      });
    }

    candidates.forEach(function (btn) {
      var text = (btn.textContent || '').replace(/\s+/g, ' ').trim();
      if (RE.test(text)) {
        btn.textContent = LABEL;
      }
    });
  }

  function run() {
    translate(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        translate(m.addedNodes[j]);
      }
      if (m.type === 'characterData' && m.target && m.target.parentElement) {
        translate(m.target.parentElement);
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
